import React from "react";
import {
    IonModal,
    IonButton,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonList,
    IonItem,
    IonLabel, IonRow, IonCol, IonFooter,
} from "@ionic/react";
import useStore from "../zustand/useStore";
import {useHistory} from "react-router";

const BecomeMemberPopup = () => {
    const {showBecomeMemberPopup,setShowBecomeMemberPopup} = useStore();
    const history = useHistory();

    const goToPage = (page) => {
        history.replace(page);
        setShowBecomeMemberPopup(false);
    };

    return (
        <IonModal isOpen={showBecomeMemberPopup} onDidDismiss={() => setShowBecomeMemberPopup(false)}>
            <IonHeader className={"job_detail_sheet_header sheet_modal_header"}>
                <IonToolbar>
                    <IonTitle>Become a Member</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent className="ion-padding membership-content">
                <IonList>
                    <IonItem className="membership-item-pop">
                        <IonLabel>
                            <h2 className="membership-title-pop">Life Member</h2>
                            <p className="membership-price-pop">₹ 25,000 + GST</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem className="membership-item-pop">
                        <IonLabel>
                            <h2 className="membership-title-pop">Annual Member</h2>
                            <p className="membership-price-pop">₹ 5,000 + GST</p>
                        </IonLabel>
                    </IonItem>
                </IonList>
            </IonContent>
            <IonFooter className="job_detail_sheet_footer ion-padding">
                <IonToolbar>
                <IonRow>
                    <IonCol>
                        <IonButton className="close_job_detail_button"  expand="block" onClick={() => setShowBecomeMemberPopup(false)}>
                            Skip
                        </IonButton>
                    </IonCol>
                    <IonCol>
                        <IonButton className="apply_job_button" expand="block" onClick={()=>goToPage('/dashboard/membership')}>
                            Proceed
                        </IonButton>
                    </IonCol>
                </IonRow>
                </IonToolbar>
            </IonFooter>
        </IonModal>
    );
};

export default BecomeMemberPopup;
